import React from 'react';
import { FaCheckCircle, FaCircle, FaHourglassHalf, FaClipboardList, FaVial, FaShieldAlt, FaVideo, FaBoxOpen } from 'react-icons/fa';

interface PatientJourneyProps {
  currentStatus: string;
}

const statusMap: { [key: string]: { label: string; order: number; icon: React.ReactNode; isCompleted?: boolean } } = {
  INTAKE_BLOCK_A_IN_PROGRESS: { label: '1. Intake Block A', order: 1, icon: <FaClipboardList />, isCompleted: false },
  INTAKE_BLOCK_A_COMPLETED: { label: '1. Intake Block A', order: 1, icon: <FaClipboardList />, isCompleted: true },
  INTAKE_BLOCK_B_IN_PROGRESS: { label: '2. Intake Block B', order: 2, icon: <FaClipboardList />, isCompleted: false },
  BOOK_HIV_TEST: { label: '3. Book HIV Test', order: 3, icon: <FaVial />, isCompleted: false },
  AWAITING_HIV_LABS: { label: '4. Awaiting HIV Test', order: 4, icon: <FaHourglassHalf />, isCompleted: false },
  LABS_COMPLETED: { label: '5. Labs Completed', order: 5, icon: <FaCheckCircle />, isCompleted: true },
  AWAITING_INSURANCE: { label: '6. Insurance Verification', order: 6, icon: <FaShieldAlt />, isCompleted: false },
  INSURANCE_VERIFIED: { label: '6. Insurance Verified', order: 6, icon: <FaShieldAlt />, isCompleted: true },
  AWAITING_TELEHEALTH: { label: '7. Telehealth Visit', order: 7, icon: <FaVideo />, isCompleted: false },
  TELEHEALTH_COMPLETED: { label: '7. Telehealth Complete', order: 7, icon: <FaVideo />, isCompleted: true },
  AWAITING_FULFILLMENT: { label: '8. PrEP Fulfillment', order: 8, icon: <FaBoxOpen />, isCompleted: false },
  FINISHED: { label: '9. Finished', order: 9, icon: <FaCheckCircle />, isCompleted: true },
};

const PatientJourney: React.FC<PatientJourneyProps> = ({ currentStatus }) => {
  const currentStatusData = statusMap[currentStatus];
  const currentOrder = currentStatusData?.order || 0;
  const isCurrentStepCompleted = currentStatusData?.isCompleted || false;

  // Get unique steps by order
  const uniqueSteps = Array.from(
    new Map(
      Object.values(statusMap).map(item => [item.order, item])
    ).values()
  ).sort((a, b) => a.order - b.order);

  return (
    <div className="patient-journey-container">
      <h3>Your PrEP Journey Progress</h3>
      <div className="journey-steps">
        {uniqueSteps.map((step, index) => {
          const isCompleted = step.order < currentOrder || (step.order === currentOrder && isCurrentStepCompleted);
          const isActive = step.order === currentOrder && !isCurrentStepCompleted;
          const statusClass = isCompleted ? 'completed' : isActive ? 'active' : 'pending';

          return (
            <div key={index} className={`journey-step ${statusClass}`}>
              <div className="step-icon">
                {isCompleted ? <FaCheckCircle /> : isActive ? step.icon : <FaCircle />}
              </div>
              <div className="step-label">{step.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PatientJourney;
